import { RefObject, useEffect, useState } from "react"

/**
 * Subscribes to media buffer updates so consumers re-render when
 * `element.buffered` changes (the live TimeRanges object alone does not).
 */
export default function useBufferedAmount(
  elementRef: RefObject<HTMLMediaElement | null>,
  mediaKey?: string | number | null
): TimeRanges | undefined {
  const [bufferedEnd, setBufferedEnd] = useState<number | null>(null)

  useEffect(() => {
    const el = elementRef.current
    if (!el) return

    const update = () => {
      const { buffered } = el
      if (!buffered.length) {
        setBufferedEnd(null)
        return
      }
      setBufferedEnd(buffered.end(buffered.length - 1))
    }

    update()
    el.addEventListener("progress", update)
    el.addEventListener("loadedmetadata", update)
    el.addEventListener("loadeddata", update)
    return () => {
      el.removeEventListener("progress", update)
      el.removeEventListener("loadedmetadata", update)
      el.removeEventListener("loadeddata", update)
      setBufferedEnd(null)
    }
  }, [elementRef, mediaKey])

  if (bufferedEnd == null) return undefined
  return elementRef.current?.buffered
}
